import axios from "axios";

export const metricApi = (headers: any, BACKEND_URL: string | undefined, entityId: string, campaignId: string | undefined, campaignVariationId: string | undefined, body?: { [key: string]: any },) => {
    const api = async (page: string) => {
        try {
            const url = `${BACKEND_URL}api/entities/${entityId}/metrics/${page}/campaign`;
            const response = await axios.post(url, { campaignId, campaignVariationId, ...body }, { headers });

            if (response.status === 200 && response.data.success) {
                return response;
            }
            // else {
            //   throw new Error(response.statusText);
            // }
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.error) {
                console.error('API request failed:', error.response.data.error);
            } else {
                console.error('API request failed:', error.message);
            }
            // throw error;
        }
    };

    return {
        async view() {
            return api('onboarding-view');
        },
        async page(pageNumber: number) {
            return api(`onboarding-complete-page-${pageNumber}`);
        },
        async complete() {
            return api('onboarding-complete');
        }
    };
};

export const templateDesign = ({ template, design, setDesign, formdata }) => {
    switch (template) {
        case "multi-question": {
            if (design.length > 0) {
                setDesign([...design]);
            }
            break;
        }
        case "single-question": {
            let arr = [];
            for (let i = 1; i <= formdata.length; i++) {
                let newArr = [i];
                arr.push(newArr);
            }
            setDesign(arr);
            break;
        }
        case 'single-page': {
            let arr = [];
            for (let i = 1; i <= formdata.length; i++) {
                arr.push(i);
            }
            setDesign([arr]);
            break;
        }
        default: {
            let arr = [];
            for (let i = 1; i <= formdata.length; i++) {
                arr.push(i);
            }
            setDesign([arr]);
            break;
        }
    }
};